var version = '6.6.4';

module.exports = version;
